import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoggerStore } from './logger.store';
import { filter, take } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { EnvironmentsEnum } from '../../../../../environments/environments.enum';

const I2G_DEBUG_MODE_PARAM = 'I2G_DEBUG_MODE';

@Injectable()
export class LoggerService {
  private _debugMode: boolean;

  constructor(
    private _route: ActivatedRoute,
    private _loggerStore: LoggerStore
  ) {
    this._debugMode = environment.debugMode;

    this._route.queryParamMap
      .pipe(
        filter(
          (queryParamMap) => queryParamMap.get(I2G_DEBUG_MODE_PARAM) !== null
        ),
        take(1)
      )
      .subscribe(() => {
        if (!this._debugMode) {
          this._debugMode = true;
        }
      });
  }

  log(...messageParts) {
    if (this._debugMode) {
      console.debug.apply(console, messageParts);
    }

    this._loggerStore.pushLog([Date.now(), messageParts]);
  }

  debug(...messageParts) {
    if (this._debugMode || environment.env !== EnvironmentsEnum.production) {
      console.debug.apply(console, messageParts);
    }
  }

  logError(error: any) {
    if (error instanceof Error) {
      this.log(error.name, error.message);
    } else {
      this.log(error);
    }
  }
}
